import { Component, OnInit } from "@angular/core";
import { VERSION } from '../../../environments/version';
import { filter } from "rxjs/operators";

import { MsalBroadcastService, MsalService } from "@azure/msal-angular";
import {
    EventMessage,
    EventType,
    AuthenticationResult,
    InteractionStatus,
} from "@azure/msal-browser";
import { createClaimsTable } from "@app/utils/claim-utils";
import { AlertService } from "@app/modules/alert";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "environments/environment";
import { GlobalService } from "@app/services/global.services";
import { UserType } from "@app/models/common";
import { GlobalConstants } from "@app/utils/global-constants";
import { setPreviousViewInStorage, setScreenModeInStorage } from "@app/utils/storage-utils";
import { ViewportScroller } from "@angular/common";

@Component({
    selector: "app-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
    appVersion = VERSION;
    loginDisplay = false;
    documentationLink = environment.docLink;
    onRequestLink = environment.onRequestLink;
    cloudRequestLink = environment.cloudRequestLink;
    aceTemplateLink = environment.aceTemplateLink;
    OPSServiceCenterLink = environment.OPSServiceCenterLink;
    displayedColumns: string[] = ["claim", "value", "description"];
    dataSource: any = [];
    options = {
        autoClose: false,
        keepAfterRouteChange: false,
    };

    globalConstants = GlobalConstants;

   instruction = {
        workorder:"Replacement of in-office hardware such as broken or missing monitors; onsite support for hardware issues; creation of SharePoint subsites. Submit a request and the Enterprise Technology team will advise when complete or reach out for details if needed.",
        consultation:"Troubleshooting and support, application demonstrations and recommendations, general technical and privacy questions and intake. Submit a request and the Enterprise Technology team will reach out for details.",
        project:"Intake and tracking of new projects. Submit a request and the Enterprise Technology team will assign to a Project Manager for further discussion.",
        cloudRequest:"Use the Cloud Intake form for all cloud-related requests, including:  New solutions, application migrations, user and access management, environment provisioning, or general cloud intake discussions. The Enterprise Cloud Team will review and follow up within 5 business days",
        aceTemplate:'Please fill in the Application Onboarding Template (ACE) to provide key details about your application as you prepare to onboard to the Supply Ontario Cloud. Open the document and create a copy using the "Save As" menu option, and include your application name in the file name (e.g., Application Onboarding Form_SO.ca). Once completed, save it in the same folder.' +
                    '<br/><b>Please note that this template is mandatory and must be completed prior to go-live.</b>',
    }

    userType : UserType;
    globalService: GlobalService;


    constructor(
        private authService: MsalService,
        private _globalService: GlobalService,
        public alertService: AlertService,
        private msalBroadcastService: MsalBroadcastService,
        private router: Router,
        private route: ActivatedRoute,
        private viewportScroller: ViewportScroller,
    ) {
        this.globalService = _globalService;
    }

    ngOnInit(): void {


        //This is useful when we redirect users to home page after submit
        this.viewportScroller.scrollToPosition([0, 0]);

        setScreenModeInStorage(GlobalConstants.REQUEST_FORM_MODE_USER);
        this.msalBroadcastService.msalSubject$
            .pipe(
                filter(
                    (msg: EventMessage) =>
                        msg.eventType === EventType.LOGIN_SUCCESS
                )
            )
            .subscribe((result: EventMessage) => {
                const payload = result.payload as AuthenticationResult;
                this.authService.instance.setActiveAccount(payload.account);
            });

        this.msalBroadcastService.inProgress$
            .pipe(
                filter(
                    (status: InteractionStatus) =>
                        status === InteractionStatus.None
                )
            )
            .subscribe(() => {
                this.setLoginDisplay();
                this.getClaims(
                    this.authService.instance.getActiveAccount()?.idTokenClaims
                );
            });
            
            //store this for situation when someone click on new request.
            setPreviousViewInStorage(this.router.url);
    }

    /**
     * this is to control content in the home page based on if the user is logged in or not.
     */
    setLoginDisplay() {
        this.loginDisplay =
            this.authService.instance.getAllAccounts().length > 0;
            this.userType = this.globalService.checkGroupAccess();
    }

    getClaims(claims: any) {
        if (claims) {
            const claimsTable = createClaimsTable(claims);
            this.dataSource = [...claimsTable];
        }
    }


    setCardWidth() {
        if (this.globalService.isPMUser || this._globalService.isSponsorUser || this.userType.isReadOnly) {
            return "col-md-6";
        } else {
            return "col-md-12";
        }
    }
    goToPage(route : string) {
        this.router.navigate([route]);
    }

    goToCouldRequest() {
        window.open(this.cloudRequestLink, '_blank');
    }
    goToACERequest() {
        window.open(this.aceTemplateLink, '_blank');
    }
    goToOnRequest() {
        window.open(this.onRequestLink, '_blank');
    }
    goToOPSServiceCenter() {
        window.open(this.OPSServiceCenterLink, '_blank');
    } 

    showNewFeatures() {

        return new Date('2025-01-31') > new Date();
    }
}
